import pino from 'pino'

export default function getLogger(text: string) {
  const level = process.env.LOG_LEVEL ? process.env.LOG_LEVEL : 'info'
  const logger = pino({
    level: level,
  })
  return logger.child({ category: text })
}
